import Modal from 'developer_components/newModal';
import {isMobile} from 'methods/utils';

function ModalDialog(args = {}) {
    this._args = Object.assign({
        id: '',
        setSession: false,
        getSession: false,
        autoClose: false,
        containerClass: '',
        header: '',
        descriptionHTML: '',
        message: '',
        useSuccessButton: false,
    }, args);

    // флаг set_session, когда нужно показать модалку после перехода
    if(this._args.setSession) {
        sessionStorage.setItem('dialog', JSON.stringify(this._args));
        return false;
    }

    // флаг set_session, когда нужно показать модалку после перехода
    if(this._args.getSession) {
        this._args = sessionStorage.getItem('dialog');
        this._args = JSON.parse(this._args);
        if(!this._args) return false;

        // удаляем
        sessionStorage.removeItem('dialog');
    }

    this._modal = Modal.createFromHTML(
       `<div class="header">
            <div class="close js-modalClose">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#D4D2D8"/>
                </svg>
            </div>
            ${this._args.header ? `<div class="title">${this._args.header}</div>` : ''}
        </div>
        <div class="content ${this._args.containerClass}">
            ${this._args.descriptionHTML}
            <p>${this._args.message}</p>
        </div>
        ${this._args.useSuccessButton ? '<div class="footer"><button class="success-button js-modalClose">Готово</button></div>' : ''}`.replace(/\s{2,}/gi, ''),
        {
            id: this._args.id,
            className: 'Modal-dialog',
        }
    );

    // наследование
    Modal.call(this, this._modal);

    this.init = function(args) {
        this.open();

        // после закрытия удаляем модалку
        if (args.id) {
            this.on('close', () => this.remove());
        }

        // автоматическое закрытие модалки
        if (this._args.autoClose === true) {
            setTimeout(() => {this.close()}, 5000);
        }
    }

    this.init(args);
}

ModalDialog.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: ModalDialog,
        enumerable: false,
        writable: true,
    }
});

export default ModalDialog;


